import { create } from "zustand";

const initialState = {
    actionModal: "none",
    selectedTypeQtn:null

};

export const useJobRequisitionStore = create((set, get) => ({
    ...initialState,
    // ===== View =====
    setActionModal: (newActionModal) => set({ actionModal: newActionModal }),
    handleConfirmationClose: () => set({ actionModal: "none" }),
    setSelectedTypeQtn:(newView)=>set({selectedType:newView})

}));